import { Api } from "./base";

const _headers = () => {
  return {
    Authorization:
      "JWT " + require("store").default.getState().onboard.user.auth_token,
    "Content-Type": "application/json"
  };
};

export default {
  getAnalyticsStory() {
    return Api.getRequest(`/analytics/v1/story_news_activity_csv/`, _headers());
  },
  getProjects() {
    return Api.getRequest(`/live-classes/v1/timekit-projects/`, _headers());
  },
  getMagicOtp() {
    return Api.getRequest(`/misc/v1/admin-magic-otp`, _headers());
  },
  createOrUpdateMagicOtp(payload) {
    return Api.post(`/misc/v1/admin-magic-otp/`, payload, _headers());
  },
  getSchoolGradeMagicOtps(query) {
    return Api.getRequest(`/misc/v1/admin-school-grade-magic-otp/?${query}`, _headers());
  },
  saveSchoolGradeMagicOtp(payload) {
    return Api.post(`/misc/v1/admin-school-grade-magic-otp/`, payload, _headers());
  },
  updateSchoolGradeMagicOtp(id, payload) {
    return Api.put(`/misc/v1/admin-school-grade-magic-otp/${id}/`, payload, _headers());
  },
  deleteSchoolGradeMagicOtp(id) {
    return Api.deleteCall(`/misc/v1/admin-school-grade-magic-otp/${id}/`, _headers());
  },
  searchSchools(query) {
    return Api.getRequest(`/school/v1/admin-school/?${query}`, _headers());
  },
  getSchoolGrades(schoolId) {
    return Api.get(`/school/v1/admin-school-class/${schoolId}?fetch_school_garde=true`, _headers());
  },
  createBulkAssignment(payload){
    return Api.post("/assignment/v1/admin-bulk-assignment/", payload, _headers());
  },
  getAdminDocumentFiles(page = 0) {
    return Api.getRequest(`/misc/v1/admin-document-file/?offset=${page}`, _headers());
  },
  createAdminDocumentFile(payload) {
    return Api.post("/misc/v1/admin-document-file/", payload, _headers());
  },
  updateAdminDocumentFile(id, payload) {
    return Api.put(`/misc/v1/admin-document-file/${id}/`, payload, _headers());
  }
};
